<template>
  <label :class="labelKls">
    <input
      v-if="trueLabel || falseLabel"
      v-model="model"
      :class="ns.be('button', 'original')"
      type="checkbox"
      :name="name"
      :tabindex="tabindex"
      :disabled="isDisabled"
      :true-value="trueLabel"
      :false-value="falseLabel"
      @change="handleChange"
      @focus="isFocused = true"
      @blur="isFocused = false"
      @click.stop
    />
    <input
      v-else
      v-model="model"
      :class="ns.be('button', 'original')"
      type="checkbox"
      :name="name"
      :tabindex="tabindex"
      :disabled="isDisabled"
      :value="label"
      @change="handleChange"
      @focus="isFocused = true"
      @blur="isFocused = false"
      @click.stop
    />
    <span v-if="isChecked"
      :class="[showButtonBadge && ns.be('button', 'badge')]"
    >
      <span />
    </span>
    <span
      v-if="$slots.default || label"
      :class="ns.be('button', 'inner')"
      :style="isChecked ? activeStyle : undefined"
    >
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { computed, inject, useSlots } from 'vue'
import { TinyColor } from '@ctrl/tinycolor'
import { useNamespace } from '@jdesign-vue/hooks'
import { checkboxGroupContextKey } from './constants'
import { useCheckbox } from './composables'
import { checkboxEmits, checkboxProps } from './checkbox'

import type { CSSProperties } from 'vue'

defineOptions({
  name: 'JdCheckboxButton',
})

const props = defineProps(checkboxProps)
defineEmits(checkboxEmits)
const slots = useSlots()

const {
  isFocused,
  isChecked,
  isDisabled,
  checkboxButtonSize,
  model,
  handleChange,
} = useCheckbox(props, slots)
const checkboxGroup = inject(checkboxGroupContextKey, undefined)
const ns = useNamespace('checkbox')
function shade(color: string, opacity: any) {
  return new TinyColor(color).setAlpha(opacity).toString()
}
//设置颜色透明度
function colorConvert(color: string) {
  if (isDisabled.value) {
    return color === '' ? '' : shade(color, 0.2)
  } else {
    return color
  }
}
const activeStyle = computed<CSSProperties>(() => {
  const fillValue = checkboxGroup?.fill?.value ?? ''
  const textColor = checkboxGroup?.textColor?.value ?? ''
  return {
    backgroundColor: showButtonBadge.value
      ? fillValue === ''
        ? ''
        : shade(fillValue, 0.1)
      : fillValue,
    borderColor: colorConvert(fillValue),
    color: colorConvert(textColor),
    boxShadow:
      fillValue && !showButtonBadge.value
        ? `-1px 0 0 0 ${fillValue}`
        : undefined,
  }
})

const showButtonBadge = computed(
  () => checkboxGroup?.showButtonBadge?.value ?? false
)

const labelKls = computed(() => {
  return [
    ns.b('button'),
    ns.bm('button', checkboxButtonSize.value),
    ns.is('disabled', isDisabled.value),
    ns.is('checked', isChecked.value),
    ns.is('focus', isFocused.value),
    ns.is('showButtonBadge', showButtonBadge.value),
  ]
})
</script>
